import { combineReducers } from 'redux';

// Front
import Layout from './layout/reducer';
import General from './general/reducer';
// Authentication
import Login from './auth/login/reducer';
import Account from './auth/register/reducer';
import ForgetPassword from './auth/forgetpwd/reducer';
import Profile from './auth/profile/reducer';
import calendar from './calendar/reducer';

const rootReducer = combineReducers({
  // public
  Layout,
  Login,
  Account,
  ForgetPassword,
  Profile,
  General,
  calendar
});

export default rootReducer;
